import { createContext } from "react";

const ListsContex = createContext();

export default ListsContex;